// import React from "react";
// import {
//   Box,
//   Container,
//   Typography,
//   Paper,
//   Avatar,
//   LinearProgress,
//   Select,
//   MenuItem,
//   FormControl,
//   useTheme,
//   useMediaQuery,
// } from "@mui/material";
// import { styled } from "@mui/material/styles";
// import Grid from "@mui/material/Grid2";
// import {
//   Star as StarIcon,
//   TrendingUp as TrendingUpIcon,
// } from "@mui/icons-material";
// import { formatName } from "../../../utils/common";

// const DashboardCard = styled(Paper)(({ theme }) => ({
//   flex: 1,
//   padding: theme.spacing(2),
//   borderRadius: 12,
//   border: "1px solid #e0e0e0",
//   display: "flex",
//   flexDirection: "column",
//   alignItems: "center",
//   [theme.breakpoints.down("sm")]: {
//     padding: theme.spacing(2),
//     margin: theme.spacing(0, 1),
//   },
// }));

// const PodiumWrapper = styled(Box)(({ theme }) => ({
//   display: "flex",
//   alignItems: "end",
//   justifyContent: "center",
//   gap: theme.spacing(3),
//   marginTop: theme.spacing(4),
//   marginBottom: theme.spacing(4),
//   [theme.breakpoints.down("md")]: {
//     flexDirection: "column",
//     alignItems: "center",
//     gap: theme.spacing(4),
//   },
// }));
// const PodiumStep = styled(Box)(({ theme, rank, bgcolor }) => {
//   const heights = { 1: 140, 2: 120, 3: 100 };
//   const height = heights[rank] || 100;

//   return {
//     display: "flex",
//     flexDirection: "column",
//     alignItems: "center",
//     position: "relative",
//     [theme.breakpoints.down("md")]: {
//       width: "100%",
//       maxWidth: 300,
//       order: rank,
//     },
//     borderRadius: "15px 15px 0 0",
//     "& .podium-base": {
//       width: 140,
//       height: height,
//       backgroundColor: bgcolor,
//       borderRadius: "15px 15px 0 0",
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "center",
//       flexDirection: "column",
//       color: rank === 1 ? "#f57c00" : rank === 2 ? "#757575" : "#d84315",
//       fontWeight: "bold",
//       fontSize: "1.2rem",
//       boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
//       [theme.breakpoints.down("md")]: {
//         width: "100%",
//         height: 100,
//         borderRadius: 12,
//       },
//       [theme.breakpoints.down("sm")]: {
//         height: 80,
//       },
//     },
//     "& .performer-info": {
//       position: "absolute",
//       top: -80,
//       display: "flex",
//       flexDirection: "column",
//       alignItems: "center",
//       gap: theme.spacing(1),
//       [theme.breakpoints.down("md")]: {
//         position: "static",
//         marginBottom: theme.spacing(2),
//       },
//     },
//   };
// });
// const RankAvatar = styled(Avatar)(({ theme, rank }) => {
//   const getBorderColor = (rank) => {
//     switch (rank) {
//       case 1:
//         return "#ffd700"; // Gold
//       case 2:
//         return "#c0c0c0"; // Silver
//       case 3:
//         return "#cd7f32"; // Bronze
//       default:
//         return "#e0e0e0";
//     }
//   };

//   return {
//     width: 80,
//     height: 80,
//     border: `4px solid ${getBorderColor(rank)}`,
//     boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
//     [theme.breakpoints.down("sm")]: {
//       width: 60,
//       height: 60,
//       border: `3px solid ${getBorderColor(rank)}`,
//     },
//   };
// });
// const ScoreBox = styled(Box)(({ theme }) => ({
//   display: "flex",
//   alignItems: "center",
//   gap: theme.spacing(0.5),
//   backgroundColor: "white",
//   padding: theme.spacing(0.5, 1),
//   borderRadius: 16,
//   boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
// }));

// function TopPerformers({ leaderBoardData }) {
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
//   const isTablet = useMediaQuery(theme.breakpoints.down("md"));

//   return (
//     <>
//       <DashboardCard elevation={0}>
//         <Box sx={{ width: "100%" }}>
//           <Typography
//             variant="h6"
//             component="h2"
//             fontWeight="600"
//             color="text.primary"
//             gutterBottom
//             sx={{ textAlign: "left", fontSize: "1.125rem" }}
//           >
//             Top Performers
//           </Typography>
//         </Box>
//         <Box
//           sx={{
//             width: "100%",
//             height: 300,
//             display: "flex",
//             flexDirection: "row",
//             justifyContent: "center",
//             alignItems: "stretch",
//             gap: 3,
//             boxSizing: "border-box",
//             overflow: "hidden",
//           }}
//         >
//           {[
//             {
//               rank:
//                 (leaderBoardData?.length > 0 && leaderBoardData[1]?.rank) ||
//                 "2",
//               name:
//                 leaderBoardData?.length > 0 && leaderBoardData[1]?.agentFullName
//                   ? formatName(leaderBoardData[1]?.agentFullName)
//                   : "",
//               score:
//                 leaderBoardData?.length > 0 &&
//                 Math.round(leaderBoardData[1]?.averagePerformance),
//               podiumColor: "#E5E7EB",
//               avatar: "/placeholder.svg",
//             },
//             {
//               rank:
//                 (leaderBoardData?.length > 0 && leaderBoardData[0]?.rank) ||
//                 "1",
//               name:
//                 leaderBoardData?.length > 0 && leaderBoardData[0]?.agentFullName
//                   ? formatName(leaderBoardData[0]?.agentFullName)
//                   : "",
//               score:
//                 leaderBoardData?.length > 0 &&
//                 Math.round(leaderBoardData[0]?.averagePerformance),

//               podiumColor: "#FEF9C3",
//               avatar: "/placeholder.svg",
//             },
//             {
//               rank:
//                 (leaderBoardData?.length > 0 && leaderBoardData[2]?.rank) ||
//                 "3",
//               name:
//                 leaderBoardData?.length > 0 && leaderBoardData[2]?.agentFullName
//                   ? formatName(leaderBoardData[2]?.agentFullName)
//                   : "",
//               score:
//                 leaderBoardData?.length > 0 &&
//                 Math.round(leaderBoardData[2]?.averagePerformance),

//               podiumColor: "#FFEDD5",
//               avatar: "/placeholder.svg",
//             },
//           ].map((performer) => (
//             <>
//               <Box
//                 key={performer.rank}
//                 sx={{
//                   width: 110,
//                   height: "100%",
//                   display: "flex",
//                   flexDirection: "column",
//                   alignItems: "center",
//                   justifyContent: "flex-end",
//                   position: "relative",
//                   backgroundColor: "transparent",
//                   pb: 2,
//                 }}
//               >
//                 <Box
//                   sx={{
//                     display: "flex",
//                     flexDirection: "column",
//                     alignItems: "center",
//                     gap: 1,
//                     mb: 1.5,
//                   }}
//                 >
//                   <Avatar

//                       src={`https://api.dicebear.com/7.x/big-ears/svg?seed=${encodeURIComponent(
//                           performer?.agentFullName || performer?.rank
//                         )}&radius=50&backgroundColor=f8f8f8`}
//                     alt={performer.name}
//                     sx={{
//                       width: 60,
//                       height: 60,
//                       border: `3px solid ${
//                         performer.rank === 1
//                           ? "#FEF9C3"
//                           : performer.rank === 2
//                           ? "#E5E7EB"
//                           : "#FFEDD5"
//                       }`,
//                     }}
//                   />
//                   <Typography fontSize={14} fontWeight={600}>
//                     {performer?.name}
//                   </Typography>
//                   <Typography fontSize={13} fontWeight={900} color="#6366F1">
//                     {/* ✨{" "} */}
//                     <svg
//                       xmlns="http://www.w3.org/2000/svg"
//                       width="16"
//                       height="16"
//                       fill="none"
//                       viewBox="0 0 24 24"
//                       stroke="currentColor"
//                       style={{
//                         verticalAlign: "middle",
//                         marginBottom: 1,
//                         color: "#6366F1",
//                       }}
//                     >
//                       <path
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                         strokeWidth="2"
//                         d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z"
//                       />
//                     </svg>{" "}
//                     {performer?.score}
//                   </Typography>
//                 </Box>

//                 {/* Podium Base */}
//                 <Box
//                   sx={{
//                     width: "100%",
//                     height:
//                       performer?.rank === 1
//                         ? 170
//                         : performer?.rank === 2
//                         ? 140
//                         : 110,
//                     backgroundColor: performer?.podiumColor,
//                     borderRadius: "10px 10px 0 0",
//                     display: "flex",
//                     justifyContent: "center",
//                     alignItems: "center",
//                     flexDirection: "column",
//                   }}
//                 >
//                   <Typography
//                     variant="h6"
//                     fontWeight={700}
//                     sx={{
//                       color:
//                         performer?.rank === 1
//                           ? "#A16207"
//                           : performer?.rank === 2
//                           ? "#757575"
//                           : performer?.rank === 3
//                           ? "#d84315"
//                           : "",
//                     }}
//                   >
//                     {performer?.rank === 1
//                       ? "1st"
//                       : performer?.rank === 2
//                       ? "2nd"
//                       : performer?.rank === 3
//                       ? "3rd"
//                       : ""}
//                   </Typography>
//                 </Box>
//               </Box>
//             </>
//           ))}
//         </Box>

//         {/*
//         <PodiumWrapper>
//           {topPerformers
//             .sort((a, b) => a.rank - b.rank)
//             .map((performer) => (
//               <PodiumStep
//                 key={performer.rank}
//                 rank={performer.rank}
//                 bgcolor={performer.bgcolor}
//               >
//                 <Box className="performer-info">
//                   <RankAvatar src={performer.avatar} rank={performer.rank} />

//                   <Typography
//                     variant={isMobile ? "body1" : "h6"}
//                     fontWeight="600"
//                     color="text.primary"
//                     textAlign="center"
//                     sx={{ mt: 1 }}
//                   >
//                     {performer.name}
//                   </Typography>

//                   <ScoreBox>
//                     <StarIcon sx={{ fontSize: 16, color: "#ffc107" }} />
//                     <Typography
//                       variant="body2"
//                       fontWeight="bold"
//                       color="text.primary"
//                     >
//                       {performer.score}
//                     </Typography>
//                   </ScoreBox>
//                 </Box>

//                 <Box className="podium-base">
//                   <Typography variant="caption" sx={{ mb: 0.5, opacity: 0.8 }}>
//                     {getRankText(performer.rank)}
//                   </Typography>
//                   <Typography
//                     variant={isMobile ? "h3" : "h2"}
//                     fontWeight="bold"
//                   >
//                     {performer.rank}
//                   </Typography>
//                 </Box>
//               </PodiumStep>
//             ))}
//         </PodiumWrapper> */}
//       </DashboardCard>
//     </>
//   );
// }

// export default TopPerformers;

// import React from "react";
// import {
//   Avatar,
//   Box,
//   Grid,
//   LinearProgress,
//   Paper,
//   Typography,
//   useMediaQuery,
//   useTheme,
// } from "@mui/material";
// import { styled } from "@mui/material/styles";

// /* ---------- colours ---------- */
// const podiumColors = {
//   1: { bg: "#9c67ff", border: "#9c67ff", text: "#ffffff" },
//   2: { bg: "#b1e2ff", border: "#b1e2ff", text: "#000000" },
//   3: { bg: "#9ffff7", border: "#9ffff7", text: "#000000" },
// };

// /* ---------- styled wrappers ---------- */
// const DashboardCard = styled(Paper)(({ theme }) => ({
//   background: "#ffffff",
//   borderRadius: 16,
//   border: "1px solid #e0e0e0",
//   padding: theme.spacing(3),
//   [theme.breakpoints.down("sm")]: { padding: theme.spacing(2) },
// }));

// const PodiumBlock = styled(Box)(() => ({
//   width: "100%",
//   borderRadius: "12px 12px 0 0",
//   display: "flex",
//   alignItems: "center",
//   justifyContent: "center",
//   boxShadow: "0 2px 8px rgba(0,0,0,.08)",
// }));

// /* ------------------------------------------------------------------ */
// export default function TopPerformers({ leaderBoardData = [] }) {
//   const theme = useTheme();
//   const downMd = useMediaQuery(theme.breakpoints.down("md"));

//   const getColor = (rank) => podiumColors[rank] || podiumColors[3];

//   return (
//     <DashboardCard elevation={0}>
//       <Grid container spacing={downMd ? 4 : 6}>
//         {/* LEFT – PODIUM */}
//         <Grid item xs={12} md={7.2}>
//           <Box textAlign="center" mb={downMd ? 2 : 3}>
//             <Typography
//               variant={downMd ? "h5" : "h4"}
//               fontWeight={800}
//               color="#6366F1"
//               gutterBottom
//             >
//               Top Performers
//             </Typography>
//             <Typography variant="body2" color="text.secondary">
//               See how your performance compares with your teammates
//             </Typography>
//           </Box>

//           {/* three podium columns */}
//           <Box
//             sx={{
//               height: 260,
//               display: "flex",
//               justifyContent: "center",
//               alignItems: "flex-end",
//               gap: 3,
//             }}
//           >
//             {[2, 1, 3].map((rank) => {
//               const idx = rank - 1;
//               const p = leaderBoardData[idx];
//               const name = p?.agentFullName ?? "-";
//               const score = Math.round(p?.averagePerformance ?? 0);
//               const clr = getColor(rank);
//               const heights = { 1: 170, 2: 140, 3: 110 };

//               return (
//                 <Box
//                   key={rank}
//                   sx={{
//                     width: 110,
//                     height: "100%",
//                     display: "flex",
//                     flexDirection: "column",
//                     alignItems: "center",
//                     justifyContent: "flex-end",
//                   }}
//                 >
//                   {/* avatar + name + score */}
//                   <Avatar
//                     src={`https://api.dicebear.com/7.x/big-ears/svg?seed=${encodeURIComponent(
//                       name
//                     )}&radius=50&backgroundColor=f8f8f8`}
//                     alt={name}
//                     sx={{
//                       width: 64,
//                       height: 64,
//                       mb: 0.5,
//                       border: `3px solid ${clr.border}`,
//                     }}
//                   />
//                   <Typography fontSize={14} fontWeight={600}>
//                     {name}
//                   </Typography>
//                   <Typography fontSize={13} fontWeight={700} color="#6366F1">
//                     ★ {score}
//                   </Typography>

//                   {/* podium */}
//                   <PodiumBlock
//                     sx={{
//                       height: heights[rank],
//                       backgroundColor: clr.bg,
//                       color: clr.text,
//                     }}
//                   >
//                     <Typography fontSize={18} fontWeight={800}>
//                       {rank === 1 ? "1st" : rank === 2 ? "2nd" : "3rd"}
//                     </Typography>
//                   </PodiumBlock>
//                 </Box>
//               );
//             })}
//           </Box>
//         </Grid>

//         {/* RIGHT – LEADERBOARD CARDS */}
//         <Grid item xs={12} md={4.8}>
//           <Paper
//             elevation={1}
//             sx={{
//               p: 3,
//               borderRadius: 4,
//               height: "100%",
//               display: "flex",
//               flexDirection: "column",
//               background: "#ffffff",
//             }}
//           >
//             <Typography
//               variant="h6"
//               fontWeight={700}
//               color="text.secondary"
//               mb={3}
//               textAlign="center"
//             >
//               Team Leaderboard
//             </Typography>

//             <Grid container spacing={2}>
//               {[1, 2, 3].map((rank) => {
//                 const p = leaderBoardData[rank - 1];
//                 const name = p?.agentFullName ?? "-";
//                 const score = Math.round(p?.averagePerformance ?? 0);
//                 const clr = getColor(rank);

//                 return (
//                   <Grid item xs={12} sm={6} md={12} key={rank}>
//                     <Paper
//                       variant="outlined"
//                       sx={{
//                         p: 2,
//                         borderRadius: 3,
//                         display: "flex",
//                         alignItems: "center",
//                         gap: 2,
//                         height: "100%",
//                         borderColor: "#e0e0e0",
//                         background: "#ffffff",
//                       }}
//                     >
//                       <Avatar
//                         sx={{
//                           width: 40,
//                           height: 40,
//                           bgcolor: clr.bg,
//                           color: clr.text,
//                           fontWeight: 800,
//                           fontSize: 16,
//                         }}
//                       >
//                         {rank}
//                       </Avatar>

//                       <Box flex={1}>
//                         <Typography fontSize="0.95rem" fontWeight={600}>
//                           {name}
//                         </Typography>
//                         <Box display="flex" alignItems="center" gap={1.5} mt={0.5}>
//                           <LinearProgress
//                             variant="determinate"
//                             value={score}
//                             sx={{
//                               height: 8,
//                               borderRadius: 4,
//                               flex: 1,
//                               backgroundColor: "#f0f0f0",
//                               "& .MuiLinearProgress-bar": {
//                                 backgroundColor: clr.bg,
//                               },
//                             }}
//                           />
//                           <Typography fontSize="0.8rem" fontWeight={700}>
//                             {score}
//                           </Typography>
//                         </Box>
//                       </Box>
//                     </Paper>
//                   </Grid>
//                 );
//               })}
//             </Grid>
//           </Paper>
//         </Grid>
//       </Grid>
//     </DashboardCard>
//   );
// }

// import React, { useEffect, useRef } from "react";
// import {
//   Avatar,
//   Box,
//   Paper,
//   Typography,
//   useMediaQuery,
//   useTheme,
// } from "@mui/material";
// import { styled } from "@mui/material/styles";
// import Grid from "@mui/material/Grid2";
// import confetti from "canvas-confetti";
// import party from "party-js";
// import { palette, theme as colorTheme } from "../../../Convoze.theme";
// import { color } from "echarts";

// const textColor =  colorTheme('palette', 'night').value;

// /* ---------- colours ---------- */
// const podiumColors = {
//   1: {
//     bg: `linear-gradient(180deg, ${ colorTheme('palette', 'rank1Border').value} 45%, transparent 100%)`,

//     border: "#C7F0FF",
//     // text: "#000",
//     text : textColor
//   },

//   2: {
//     bg: `linear-gradient(180deg, ${ colorTheme('palette', 'rank2Border').value} 45%, transparent 100%)`,
//     border: "#FEF9C3",
//     // text: "#000000",
//     text :textColor
//   },
//   3: {
//     bg: `linear-gradient(180deg, ${ colorTheme('palette', 'rank3Border').value} 45%, transparent 100%)`,
//     border: "#FFEDD5",
//     // text: "#000000"
//     text : textColor
//   },
// };

// const avatarBg = {
//   // 1: "#FEF9C3",
//   // 2: "#e9f7ccff",
//   // 3: "#FFEDD5",
//   1: colorTheme('palette', 'rank1Bg').value,
//   2: colorTheme('palette', 'rank2Bg').value,
//   3: colorTheme('palette', 'rank3Bg').value
// };

// /* ---------- styled wrappers ---------- */
// const DashboardCard = styled(Paper)(({ theme }) => ({
//   // background: colorTheme('palette', 'white').value,
//   borderRadius: 16,
//   // border: "1px solid #e0e0e0",
//   border : `1px solid ${colorTheme('palette', 'secondary').value }`,
//   padding: 3,
//   [theme.breakpoints.down("sm")]: { padding: 2 },
// }));

// const PodiumBlock = styled(Box)(() => ({
//   width: "100%",
//   borderRadius: "10px 10px 0 0",
//   display: "flex",
//   flexDirection: "column",
//   alignItems: "center",
//   justifyContent: "flex-start",
//   paddingTop: 8,
// }));

// /* ---------- trophy svg component ---------- */
// const Trophy = () => (
//   <Box sx={{ mb: 0.5, p: 1 }}>
//     <svg
//       xmlns="http://www.w3.org/2000/svg"
//       width="20"
//       height="20"
//       // color="#6366F1"
//       color ={colorTheme('palette', 'primary').value }
//       viewBox="0 0 24 24"
//       fill="none"
//       stroke="currentColor"
//       strokeWidth="2"
//       strokeLinecap="round"
//       strokeLinejoin="round"
//       className="lucide lucide-trophy"
//     >
//       <path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6" />
//       <path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18" />
//       <path d="M4 22h16" />
//       <path d="M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22" />
//       <path d="M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22" />
//       <path d="M18 2H6v7a6 6 0 0 0 12 0V2Z" />
//     </svg>
//   </Box>
// );

// const shootConfetti = () => {
//   const duration = 2 * 1000;
//   const end = Date.now() + duration;
//   const colours = ["#6366F1", "#10B981", "#F59E0B", "#EF4444", "#EC4899"];

//   (function frame() {
//     confetti({
//       particleCount: 4,
//       angle: 60,
//       spread: 55,
//       origin: { x: 0 },
//       colors: colours,
//     });
//     confetti({
//       particleCount: 4,
//       angle: 120,
//       spread: 55,
//       origin: { x: 1 },
//       colors: colours,
//     });
//     if (Date.now() < end) requestAnimationFrame(frame);
//   })();
// };

// /* ------------------------------------------------------------------ */
// export default function TopPerformers({ leaderBoardData = [] }) {

//   const shootStars = () => {
//     const colours = [
//       "#00bfffff",
//       "#f2a5fcff",
//       "#ffd68eff",
//       "#88f88eff",
//       "#adbeffff",
//     ];
//     const node = document.querySelector("#podium-stars-anchor");

//     const burst = () =>
//       party.sparkles(node, {
//         count: party.variation.range(20, 30),
//         speed: party.variation.range(200, 400),
//         size: party.variation.range(0.8, 1.4),
//         shapes: ["star"],
//         color: colours,
//         gravity: 0.1,
//         decay: 0.92,
//         angle: -90,
//         spread: 60,
//       });

//     // 3 rapid salvos feel celebratory
//     burst();
//     setTimeout(burst, 120);
//     setTimeout(burst, 240);
//   };

//   const theme = useTheme();
//   const downMd = useMediaQuery(theme.breakpoints.down("md"));

//   const getColor = (rank) => podiumColors[rank] || podiumColors[3];
//   const canvasRef = useRef(null);

// useEffect(() => {

//   if (canvasRef.current) canvasRef.current.style.display = 'block';

//   const timer = setTimeout(() => {
//     if (!canvasRef.current) return;

//     const myConfetti = confetti.create(canvasRef.current, {
//       resize: true,
//       useWorker: true,
//     });

//     const end = Date.now() + 1000;

//     (function frame() {
//       myConfetti({
//         particleCount: 4,
//         angle: 60,
//         spread: 55,
//         origin: { x: 0 },
//         colors: ["#6366F1", "#10B981", "#F59E0B", "#EF4444", "#EC4899"],
//       });
//       myConfetti({
//         particleCount: 4,
//         angle: 120,
//         spread: 55,
//         origin: { x: 1 },
//         colors: ["#6366F1", "#10B981", "#F59E0B", "#EF4444", "#EC4899"],
//       });
//       if (Date.now() < end) requestAnimationFrame(frame);
//     })();

//     // /* 2. PARTY.JS STARS – start when confetti finishes */
//     // setTimeout(() => {
//     //   const colours = [
//     //     "#00bfffff",
//     //     "#f2a5fcff",
//     //     "#ffd68eff",
//     //     "#88f88eff",
//     //     "#adbeffff",
//     //   ];
//     //   const node = document.querySelector("#podium-stars-anchor");

//     //   const burst = () =>
//     //     party.sparkles(node, {
//     //       count: party.variation.range(20, 30),
//     //       speed: party.variation.range(200, 400),
//     //       size: party.variation.range(0.8, 1.4),
//     //       shapes: ["star"],
//     //       color: colours,
//     //       gravity: 0.1,
//     //       decay: 0.92,
//     //       angle: -90,
//     //       spread: 60,
//     //     });

//     //   burst();
//     //   setTimeout(burst, 120);
//     //   setTimeout(burst, 240);
//     // }, duration); // 2 s later
//   }, [])

//   const heights = { 1: 170, 2: 140, 3: 110 };

//   return (
//     <DashboardCard sx={{ position: "relative", overflow: "hidden" }}>

//       <Box display="flex" flexDirection="column" gap={4}>
//         <Box textAlign="center" mb={downMd ? 2 : 3}>
//           <Typography
//             variant={downMd ? "h5" : "h6"}
//             fontWeight={600}
//             gutterBottom
//           >
//             Top Performers
//           </Typography>
//           <Typography variant="body2" color="text.secondary">
//             See how your performance compares with your teammates
//           </Typography>
//         </Box>

//         {/* three podium columns */}
//         <Box
//           sx={{
//             minHeight: 260,
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "flex-end",
//             gap: 3,
//           }}
//         >
//           {[2, 1, 3].map((rank) => {
//             const idx = rank - 1;
//             const p = leaderBoardData[idx];
//             const name = p?.agentFullName ?? "-";
//             const score = Math.round(p?.averagePerformance ?? 0);
//             const clr = getColor(rank);

//             return (
//               <Grid key={rank} size={{ xs: 12, md: 6, lg: 3 }}>
//                 <Box
//                   sx={{
//                     display: "flex",
//                     flexDirection: "column",
//                     alignItems: "center",
//                     justifyContent: "flex-end",
//                   }}
//                 >
//                   <Box
//                     sx={{
//                       display: "flex",
//                       flexDirection: "column",
//                       justifyContent: "center",
//                       alignItems: "center",
//                     }}
//                   >
//                     {/* avatar + name + score */}
//                     <Avatar
//                       src={`https://api.dicebear.com/7.x/personas/svg?seed=${encodeURIComponent(
//                         name
//                       )}&radius=50&backgroundColor=f8f8f8`}
//                       alt={name}
//                       sx={{
//                         width: 80,
//                         height: 80,
//                         mb: 0.5,
//                         borderRadius: 2,
//                         // background: clr.bg,
//                         // background: "#f0f0f0",
//                         backgroundColor: avatarBg[rank],
//                         p: 1,
//                       }}
//                     />
//                     <Typography
//                       textAlign={"center"}
//                       fontSize={16}
//                       fontWeight={600}
//                     >
//                       {name}
//                     </Typography>
//                   </Box>

//                   {/* podium with trophy on top */}
//                   <PodiumBlock
//                     sx={{
//                       height: heights[rank],
//                       background: clr.bg,
//                       color: clr.text,
//                       marginTop: "0.5rem",
//                     }}
//                   >
//                     {/* <Box sx={{width:45,height:20,borderRadius:1,justifyContent:"center",alignItems:"center"}}> */}
//                     <Trophy />
//                     {/* </Box> */}

//                     <Typography fontSize={18} fontWeight={600}>
//                       {rank === 1 ? "1st" : rank === 2 ? "2nd" : "3rd"}
//                     </Typography>
//                     <Typography fontSize={13} fontWeight={700}>
//                       ★ {score}
//                     </Typography>
//                   </PodiumBlock>
//                 </Box>
//               </Grid>
//             );
//           })}
//         </Box>
//       </Box>

//       <canvas
//         ref={canvasRef}
//         style={{
//           position: "absolute",
//           top: 0,
//           left: 0,
//           width: "100%",
//           height: "100%",
//           pointerEvents: "none",
//           // animation: "1ms forwards",
//           // animationDelay: "1000ms",
//           // animationName: "hide",
//         }}
//       />
//     </DashboardCard>
//   );
// }

import React, { useEffect, useRef } from "react";
import {
  Avatar,
  Box,
  Paper,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import Grid from "@mui/material/Grid2";
import confetti from "canvas-confetti";
import party from "party-js";
import { palette, theme as colorTheme } from "../../../Convoze.theme";

const textColor = colorTheme("palette", "night").value;

/* ---------- colours ---------- */
const podiumColors = {
  1: {
    // bg: `linear-gradient(180deg, ${
    //   colorTheme("palette", "rank1Bg").value
    // } 45%, transparent 100%)`,
    // border: "#C7F0FF",
    border: colorTheme("palette", "rank1Border").value,
    text: textColor,
    bg: "#c4e0ec",
  },
  2: {
    // bg: `linear-gradient(180deg, ${
    //   colorTheme("palette", "rank2Bg").value
    // } 45%, transparent 100%)`,
    // border: "#FEF9C3",
    border: colorTheme("palette", "rank2Border").value,
    text: textColor,
    bg: "#EDE5FB",
  },
  3: {
    // bg: `linear-gradient(180deg, ${
    //   colorTheme("palette", "rank3Bg").value
    // } 45%, transparent 100%)`,
    // border: "#FFEDD5",
    border: colorTheme("palette", "rank3Border").value,
    text: textColor,
    bg: "#c2c9db",
  },
};

const avatarBg = {
  1: colorTheme("palette", "rank1Bg").value,
  2: colorTheme("palette", "rank2Bg").value,
  3: colorTheme("palette", "rank3Bg").value,
};

/* ---------- styled wrappers ---------- */
const DashboardCard = styled(Paper)(({ theme }) => ({
  borderRadius: 16,
  // border: `1px solid ${colorTheme("palette", "secondary").value}`,
  padding: 3,
  [theme.breakpoints.down("sm")]: { padding: 2 },
}));

const PodiumBlock = styled(Box)(() => ({
  width: "100%",
  borderRadius: "10px 10px 0 0",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "flex-start",
  paddingTop: 8,
}));

/* ---------- trophy svg component ---------- */
const Trophy = () => (
  <Box sx={{ mb: 0.5, p: 1 }}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      color={colorTheme("palette", "primary").value}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="lucide lucide-trophy"
    >
      <path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6" />
      <path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18" />
      <path d="M4 22h16" />
      <path d="M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22" />
      <path d="M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22" />
      <path d="M18 2H6v7a6 6 0 0 0 12 0V2Z" />
    </svg>
  </Box>
);

const shootConfetti = () => {
  const duration = 2 * 1000;
  const end = Date.now() + duration;
  // const colours = ["#6366F1", "#10B981", "#F59E0B", "#EF4444", "#EC4899"];
  const colours = [
    colorTheme("palette", "primary").value,
    colorTheme("palette", "positive").value,
    colorTheme("palette", "neutral").value,
    colorTheme("palette", "negative").value,
    colorTheme("palette", "primary").value,
  ](function frame() {
    confetti({
      particleCount: 4,
      angle: 60,
      spread: 55,
      origin: { x: 0 },
      colors: colours,
    });
    confetti({
      particleCount: 4,
      angle: 120,
      spread: 55,
      origin: { x: 1 },
      colors: colours,
    });
    if (Date.now() < end) requestAnimationFrame(frame);
  })();
};

/* ------------------------------------------------------------------ */
export default function TopPerformers({ leaderBoardData = [] }) {
  const shootStars = () => {
    // const colours = [
    //   "#00bfffff",
    //   "#f2a5fcff",
    //   "#ffd68eff",
    //   "#88f88eff",
    //   "#adbeffff",
    // ];
    const colours = [
      colorTheme("palette", "primary").value,
      colorTheme("palette", "positive").value,
      colorTheme("palette", "neutral").value,
      colorTheme("palette", "negative").value,
      colorTheme("palette", "primary").value,
    ];

    const node = document.querySelector("#podium-stars-anchor");

    const burst = () =>
      party.sparkles(node, {
        count: party.variation.range(20, 30),
        speed: party.variation.range(200, 400),
        size: party.variation.range(0.8, 1.4),
        shapes: ["star"],
        color: colours,
        gravity: 0.1,
        decay: 0.92,
        angle: -90,
        spread: 60,
      });

    burst();
    setTimeout(burst, 120);
    setTimeout(burst, 240);
  };

  const theme = useTheme();
  const downMd = useMediaQuery(theme.breakpoints.down("md"));

  const getColor = (rank) => podiumColors[rank] || podiumColors[3];
  const canvasRef = useRef(null);

  useEffect(() => {
    if (canvasRef.current) canvasRef.current.style.display = "block";

    const timer = setTimeout(() => {
      if (!canvasRef.current) return;

      const myConfetti = confetti.create(canvasRef.current, {
        resize: true,
        useWorker: true,
      });

      const end = Date.now() + 1000;

      (function frame() {
        myConfetti({
          particleCount: 4,
          angle: 60,
          spread: 55,
          origin: { x: 0 },
          // colors: ["#6366F1", "#10B981", "#F59E0B", "#EF4444", "#EC4899"],
          colours: [
            colorTheme("palette", "primary").value,
            colorTheme("palette", "positive").value,
            colorTheme("palette", "neutral").value,
            colorTheme("palette", "negative").value,
            colorTheme("palette", "primary").value,
          ],
        });
        myConfetti({
          particleCount: 4,
          angle: 120,
          spread: 55,
          origin: { x: 1 },
          // colors: ["#6366F1", "#10B981", "#F59E0B", "#EF4444", "#EC4899"],
          colours: [
            colorTheme("palette", "primary").value,
            colorTheme("palette", "positive").value,
            colorTheme("palette", "neutral").value,
            colorTheme("palette", "negative").value,
            colorTheme("palette", "primary").value,
          ],
        });
        if (Date.now() < end) requestAnimationFrame(frame);
      })();
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  const heights = { 1: 170, 2: 140, 3: 110 };

  return (
    <DashboardCard sx={{ position: "relative", overflow: "hidden" }}>
      <Box display="flex" flexDirection="column" gap={4}>
        <Box textAlign="center" mb={downMd ? 2 : 3}>
          <Typography
            variant={downMd ? "h5" : "h6"}
            fontWeight={600}
            gutterBottom
          >
            Top Performers
          </Typography>
          <Typography variant="body2" color="text.secondary">
            See how your performance compares with your teammates
          </Typography>
        </Box>

        {/* three podium columns */}
        <Box
          sx={{
            minHeight: 260,
            display: "flex",
            justifyContent: "center",
            alignItems: "flex-end",
            gap: 3,
          }}
        >
          {[2, 1, 3].map((rank) => {
            const idx = rank - 1;
            const p = leaderBoardData[idx];
            const name = p?.agentFullName ?? "-";
            const score = Math.round(p?.averagePerformance ?? 0);
            const clr = getColor(rank);

            return (
              <Grid key={rank} size={{ xs: 12, md: 6, lg: 3 }}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "flex-end",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    {/* avatar + name + score */}
                    <Avatar
                      src={`https://api.dicebear.com/7.x/personas/svg?seed=${encodeURIComponent(
                        name
                      )}&radius=50&backgroundColor=f8f8f8`}
                      alt={name}
                      sx={{
                        width: 80,
                        height: 80,
                        mb: 0.5,
                        borderRadius: 2,
                        // backgroundColor: avatarBg[rank],
                        p: 1,
                      }}
                    />
                    <Typography
                      textAlign={"center"}
                      fontSize={16}
                      fontWeight={600}
                    >
                      {name}
                    </Typography>
                  </Box>

                  {/* podium with trophy on top */}
                  <PodiumBlock
                    sx={{
                      height: heights[rank],
                      background: clr.bg,
                      // color: clr.text,
                      color: "black",
                      marginTop: "0.5rem",
                    }}
                  >
                    <Trophy />

                    <Typography fontSize={20} fontWeight={600}>
                      {rank === 1 ? "1st" : rank === 2 ? "2nd" : "3rd"}
                    </Typography>
                    <Typography fontSize={13} fontWeight={700}>
                      ★ {score}
                    </Typography>
                  </PodiumBlock>
                </Box>
              </Grid>
            );
          })}
        </Box>
      </Box>

      <canvas
        ref={canvasRef}
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          pointerEvents: "none",
        }}
      />
    </DashboardCard>
  );
}
